import React from 'react'
import { useIntl } from 'react-intl'
import UrgencyLabel from 'LuxKit/Label/UrgencyLabel'

interface Props {
  variants: Array<App.MerchandiseOfferVariant>
}

function MerchandiseSaleLabel({ variants }: Props) {
  const intl = useIntl()
  const isOnSale = variants.some(variant => variant.price !== variant.regularPrice)

  if (!isOnSale) {
    return null
  }

  return <UrgencyLabel variant="critical2">
    {intl.formatMessage({
      id: '6QesySpAMMsdObyC-q6z',
      defaultMessage: 'Sale',
      description: 'Urgency label indicating a merchandise item is on sale',
    })}
  </UrgencyLabel>
}

export default MerchandiseSaleLabel
